import { Box } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";

const data1 = [
  {
    country: "USA",
    burger: 500,
    donut: 32,
  },
  {
    country: "China",
    burger: 300,
    donut: 50,
  },
  {
    country: "Japan",
    burger: 200,
    donut: 70,
  },
  {
    country: "Germany",
    burger: 100,
    donut: 32,
  },
];

const Chart2 = () => {
  return (
    <>
      <ResponsiveBar
        data={data1}
        keys={["burger", "donut"]}
        indexBy="country"
        margin={{ top: 50, right: 15, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={["#42a5f5", "#32CD32"]}
        fill={[
          {
            match: {
              id: "burger",
            },
            id: "dots",
          },
          {
            match: {
              id: "donut",
            },
            id: "lines",
          },
        ]}
        tooltip={({ id, value }) => (
          <Box
            style={{
              borderRadius: "0.75rem",
              border: "1px solid #fff",
              backgroundColor: "#ffffff",
              padding: "1rem",
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Box
                style={{
                  width: "0.25rem",
                  borderRadius: "0.25rem",
                  alignSelf: "stretch",
                  backgroundColor: "#7E7988", //hover border color
                }}
              ></Box>
              <Box style={{ flex: 1 }}>
                <strong
                  style={{
                    display: "block",
                    fontWeight: 500,
                    fontSize: "1rem",
                    lineHeight: "1rem",
                    color: "#9d99a8",
                  }}
                >
                  {id}
                </strong>
                <span
                  style={{
                    fontSize: "1.125rem",
                    lineHeight: "1.875rem",
                    color: "#1e1c24",
                  }}
                >
                  Value: <span style={{ fontWeight: 600 }}>{value}</span>
                </span>
              </Box>
            </Box>
          </Box>
        )}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "country",
          legendPosition: "middle",
          legendOffset: 32,
          truncateTickAt: 0,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "total",
          legendPosition: "middle",
          legendOffset: -40,
          truncateTickAt: 0,
        }}
        enableGridY={false}
        enableLabel={false}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "top-left",
            direction: "row",
            justify: false,
            translateX: -29,
            translateY: -30,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 0,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 12,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: "#7E7988",
              },
            },
            domain: {
              line: {
                stroke: "#e0e0e0",
                strokeWidth: 1,
              },
            },
          },
          grid: {
            line: {
              stroke: "#F3F3F4",
              strokeWidth: 1,
            },
          },
          legends: {
            text: {
              fontSize: 14,
              fill: "#7E7988",
              outlineWidth: 0,
              //outlineColor: "transparent",
            },
          },
        }}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={(e) =>
          e.id + ": " + e.formattedValue + " in country: " + e.indexValue
        }
      />
    </>
  );
};

export default Chart2;
